import { cx } from './cx';

export interface TabItem {
  key: string;
  label: string;
  count?: number;
  disabled?: boolean;
}

interface TabsProps {
  items: TabItem[];
  active: string;
  onChange: (key: string) => void;
}

/** Rounded segmented pill control for switching in-page views. */
export function Tabs({ items, active, onChange }: TabsProps) {
  return (
    <div className="rfp-tabs" role="tablist">
      {items.map((item) => {
        const isActive = item.key === active;

        return (
          <button
            aria-selected={isActive}
            disabled={item.disabled}
            title={item.disabled ? 'Coming soon' : undefined}
            className={cx('rfp-tab', isActive && 'rfp-tab--active')}
            key={item.key}
            onClick={() => onChange(item.key)}
            role="tab"
            type="button"
          >
            {item.label}
            {item.count !== undefined && <span className="rfp-tab__count">{item.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
